import { Pipe, PipeTransform } from '@angular/core';
import { Translation } from '../models/translation.model';

/**Pipe che verifica se debba essere visualizzato il tag see also */
@Pipe({
  name: 'showSeealsoTag'
})
export class ShowSeealsoTagPipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia PipeTransform che effettua il controllo
   * @param reference {Translation} traduzione da controllare
   * @param seeAlsoIncomeList {Translation[]} lista di traduzioni che puntano alla voce di glossario come see also
   */
  transform(reference: Translation, seeAlsoIncomeList: Translation[]): boolean {
    return seeAlsoIncomeList.includes(reference);
  }

}
